// Translator helper — wraps hardcoded Spanish strings and translates to the
// current i18next language via a master dictionary. Fallback: returns source.
import i18n from "./index";
import DICT from "./dict";

export function tr(src) {
  if (src === undefined || src === null) return src;
  if (typeof src !== "string") return src;
  const lang = i18n.language?.slice(0, 2) || "es";
  if (lang === "es") return src;
  const pool = DICT[lang];
  if (!pool) return src;
  return pool[src] ?? src;
}

// Hook version so components re-render on language change
import { useTranslation } from "react-i18next";
export function useTr() {
  const { i18n: i18nInstance } = useTranslation();
  const lang = (i18nInstance.language || "es").slice(0, 2);
  return (src) => {
    if (src === undefined || src === null) return src;
    if (typeof src !== "string") return src;
    if (lang === "es") return src;
    const pool = DICT[lang];
    if (!pool) return src;
    return pool[src] ?? src;
  };
}
